// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"ba201a6f","667":"b95c30ea","687":"d3f20208"}[chunkId] + ".chunk.js";
};